import { useState, useEffect } from "react";
import Index from "./pages/index";

// Spinner con efecto de barras tipo ecualizador
function Spinner({ isLoading }) {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-neutral-900 transition-opacity duration-700 z-50 ${
        isLoading ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex gap-1">
        {[...Array(10)].map((_, i) => (
          <span
            key={i}
            className="w-1.5 h-6 bg-gray-400 animate-loader"
            style={{
              animationDelay: `${i * 0.1}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validPaths = ["/"]; // puedes agregar más rutas válidas aquí si en el futuro las necesitas
    const currentPath = window.location.pathname;

    if (!validPaths.includes(currentPath)) {
      window.location.replace("/");
      return;
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Spinner isLoading={loading} />
      {!loading && <Index />}
    </>
  );
}

export default App;
